import { TableInstance } from 'react-table';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';
import { SubscriptionsTableSubscriptionFragment } from './__generated__/SubscriptionsTable.graphql';

export function SubscriptionsTablePagination({
  table,
}: {
  table: TableInstance<SubscriptionsTableSubscriptionFragment>;
}) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function SubscriptionsTablePageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<SubscriptionsTableSubscriptionFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label="subscriptions per page"
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
